/*
  Mid-Year Sale countdown.

  Server (Liquid) computes the authoritative remaining seconds via epoch math
  using the Melbourne offset, then prints it into [data-sale-countdown] as
  data-remaining. The client only decrements — no client-side timezone parsing,
  so it is immune to the visitor's local clock/zone being wrong.

  Markup contract (per countdown instance):
    <div data-sale-countdown data-remaining="147600">
      <span data-cd="d"></span> <span data-cd="h"></span>
      <span data-cd="m"></span> <span data-cd="s"></span>
    </div>
  Any subset of d/h/m/s slots may be present. When days are omitted, hours roll
  up to include the days portion (so a 48h timer can show 47/59/59 not 1 day).
*/
(function () {
  // The tag can appear more than once (PDP + cart drawer) — load once.
  if (window.__saleCdLoaded) return;
  window.__saleCdLoaded = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function render(el, remaining) {
    var hasDays = el.querySelector('[data-cd="d"]');
    var d = Math.floor(remaining / 86400);
    var rem = remaining - (hasDays ? d * 86400 : 0);
    var h = Math.floor(rem / 3600);
    var m = Math.floor((rem % 3600) / 60);
    var s = Math.floor(rem % 60);

    var slot;
    if ((slot = el.querySelector('[data-cd="d"]'))) slot.textContent = pad(d);
    if ((slot = el.querySelector('[data-cd="h"]'))) slot.textContent = pad(h);
    if ((slot = el.querySelector('[data-cd="m"]'))) slot.textContent = pad(m);
    if ((slot = el.querySelector('[data-cd="s"]'))) slot.textContent = pad(s);
  }

  function start(el) {
    if (el.__saleCdStarted) return;
    el.__saleCdStarted = true;

    var remaining = parseInt(el.getAttribute('data-remaining'), 10);
    if (isNaN(remaining) || remaining <= 0) {
      el.setAttribute('data-ended', 'true');
      render(el, 0);
      return;
    }

    // Anchor to a client-side reference so drift across long-running tabs
    // is corrected against the original server value.
    var startedAt = Date.now();
    var initial = remaining;

    function tick() {
      var elapsed = Math.floor((Date.now() - startedAt) / 1000);
      var left = initial - elapsed;
      if (left <= 0) {
        render(el, 0);
        el.setAttribute('data-ended', 'true');
        clearInterval(el.__saleCdTimer);
        return;
      }
      render(el, left);
    }

    render(el, remaining);
    el.__saleCdTimer = setInterval(tick, 1000);
  }

  function init(root) {
    (root || document)
      .querySelectorAll('[data-sale-countdown]')
      .forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init after AJAX section re-renders (cart drawer, etc.).
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('sale:rescan', function () { init(); });

  // The cart drawer (and cart page) re-render via innerHTML on every add /
  // quantity change, which replaces countdown nodes with their static "00"
  // placeholders and never re-runs scripts. Watch for new countdown nodes and
  // start them. start() is guarded, so re-scanning is cheap and idempotent.
  function watch() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute('data-sale-countdown')) start(node);
          else if (node.querySelector && node.querySelector('[data-sale-countdown]')) init(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);

  window.SaleCountdown = { init: init };
})();
